import React from 'react';
import { makeConnect } from '../../infrastructure/components/mobx-extensions';
import { EventsVM } from './events.viewmodel';

const EventsContext = React.createContext<EventsVM>(null);

const connectEventsVM = makeConnect(EventsContext);

export { EventsContext, connectEventsVM };
